export default {
  notFound: "A kérdőív/űrlap nem található!",
};
